import type { Box } from "./Box";

type BoxResolver = (id: string) => Box | undefined;

let boxResolver: BoxResolver = () => undefined;

export function setBoxResolver(resolver: BoxResolver): void {
  boxResolver = resolver;
}

export function resolveBoxById(id: string): Box | undefined {
  return boxResolver(id);
}
